import React from 'react';
import styles from './InputComponent.module.css';

interface Props {
  label?: string;
  placeholder?: string;
  left?: React.ReactNode;
  right?: React.ReactNode;
  readonly?: boolean;
  value: string;
  onChange: (value: string) => any;
  error?: string;
  disabled?: boolean;
  id?: string;
  type?: string;
  required?: boolean;
  className?: string;
}

const InputComponent = React.forwardRef<HTMLInputElement, Props>(function InputComponent(
  {
    label,
    placeholder,
    left,
    right,
    readonly = false,
    value,
    onChange,
    error,
    disabled = false,
    id,
    type = 'text',
    required = false,
    className = '',
    ...rest
  },
  ref
) {
  return (
    <div className={`${styles.inputContainer} ${className}`} ref={ref}>
      {label && <div className={styles.inputLabel}>{label}</div>}
      <div className={`${styles.inputWrapper} ${disabled ? styles.inputWrapperDisabled : ''}`}>
        {left}
        <input
          id={id}
          disabled={disabled}
          type={type}
          readOnly={readonly}
          className={styles.input}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          {...rest}
        />
        {right}
      </div>
      {error && <div className={styles.textInputError}>{error}</div>}
    </div>
  );
});

export default InputComponent;
